import React from 'react';
import PropTypes from 'prop-types';

const icons = {
  shoe: require('../route.svg'),
  robot: require('./robot.svg'),
  apple: require('./apple.svg'),
  battery: require('./battery.svg'),
  bicycle: require('./bicycle.svg'),
  brain: require('./brain.svg'),
  bug: require('./bug.svg'),
  burger: require('./burger.svg'),
  carrot: require('./carrot.svg'),
  cherry: require('./cherry.svg'),
  chip: require('./chip.svg'),
  city: require('./city.svg'),
  computer: require('./computer.svg'),
  dna: require('./dna.svg'),
  drink: require('./drink.svg'),
  drone: require('./drone.svg'),
  fishbone: require('./fishbone.svg'),
  flash: require('./flash.svg'),
  envelope: require('./envelope.svg'),
  globe: require('./globe.svg'),
  group: require('./group.svg'),
  'hammer-straight': require('./hammer-straight.svg'),
  hammer: require('./hammer.svg'),
  heart: require('./heart.svg'),
  'lightbulb-dotted': require('./lightbulb-dotted.svg'),
  lightbulb: require('./lightbulb.svg'),
  'magnifying-glas': require('./magnifying-glas.svg'),
  paperplane: require('./paperplane.svg'),
  pill: require('./pill.svg'),
  plant: require('./plant.svg'),
  pinwheel: require('./pinwheel.svg'),
  printer: require('./printer.svg'),
  pulse: require('./pulse.svg'),
  robotarm: require('./robotarm.svg'),
  rope: require('./rope.svg'),
  shovel: require('./shovel.svg'),
  solarplant: require('./solarplant.svg'),
  speachbubbles: require('./speachbubbles.svg'),
  spiderweb: require('./spiderweb.svg'),
  star: require('./star.svg'),
  tablet: require('./tablet.svg'),
  telescope: require('./telescope.svg'),
  watch: require('./watch.svg'),
  wave: require('./wave.svg'),
  world: require('./world.svg')
};

const FuturiumIcon = ({ icon }) => {
  const LoadedIcon = icons[icon].default;

  return <LoadedIcon />;
};
FuturiumIcon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default FuturiumIcon;
